import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  useLobbyStore,
  TableUsersWinBets,
  useTranslation,
  DefaultQueryParams,
  parseQuery,
  FreeBetsWrapper,
} from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import { Statistics } from '../statistics';
import GameResults from '../gameResults';
import { WinBetType } from '../../components/winBetType';
import { RoundCards } from '../../components/roundCards';
import { RoundInfo } from '../../components/roundInfo';
import { ChipActionWrapper } from '../../components/chipsActionWrapper/chipActionWrapper';
import { GameCardHolderContainer } from '../gameCardHolderContainer';
import WinPopUp from '../../components/winPopUp';
import { winningAmountStore } from '../../store/winningAmountStore';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';
import { cardsStore } from '../../store/cardsStore';
import { BetTypesWrapper } from '../betTypes';
import { CardHolderWebView } from '../../components/cardHolderView';
import Logo from '../../components/logo';
import { turboGameService } from '../../services/TurboGameService';
import { gameStore } from '../../store/gameStore';
import { TURBO_GAME_ID } from '../../enums/constants';
import { doBetStore } from '../../store/doBetStore';

const GameContent = observer(({ isReplay }) => {
  const t = useTranslation();
  const { isShuffle } = cardsStore;
  const { isBetsClosed } = gameStore;
  const { betsModels } = doBetStore;
  const { roomName } = useLobbyStore();
  const { winningAmountByMode } = winningAmountStore;
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_GAME_ID;

  return (
    <div className={`baccarat-game-page ${isTurbo ? 'orange' : roomName.toLowerCase()}`}>
      <FreeBetsWrapper />
      <div className='baccarat-game-page-top'>
        <div className={`baccarat-game-top-container ${isTurbo ? 'is-turbo' : ''}`}>
          <Logo />
          {!isShuffle ? <GameCardHolderContainer innerComp={CardHolderWebView} /> : null}
          {isShuffle ? <ShuffleCardsWrapper /> : null}
          {!isReplay && <RoundInfo />}
          <RoundCards />
          <WinBetType />
          {!isShuffle && !isReplay ? <ChipActionWrapper /> : null}
          {!isBetsClosed && isTurbo && !isShuffle && (
            <div className='baccarat-deal-button-holder'>
              <button
                className={`baccarat-deal-button ${betsModels.length ? 'active' : ''}`}
                onClick={() => turboGameService.sendBet()}
              >
                <span className='baccarat-deal-button-text'>{t('DEAL')}</span>
              </button>
            </div>
          )}
        </div>
        {winningAmountByMode ? <WinPopUp winningAmount={winningAmountByMode} /> : null}
      </div>
      <div className='baccarat-game-page-bottom'>
        <div className='game-page-bottom-inner'>
          <GameResults />
          <BetTypesWrapper />
          <Statistics isReplay={isReplay} />
          {!isReplay && <TableUsersWinBets />}
        </div>
      </div>
    </div>
  );
});

export default GameContent;
